// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1614af7d","453":"b4f479a1","455":"df7f959f"}[chunkId] + ".chunk.js";
};